import React from 'react';
import CreatableSelect from 'react-select/creatable';
import {SingleValue} from "react-select";
import {IOptionType} from "../../../types/common";
import { OverlayTooltip } from '../../../components';

interface ItemMPSelectProps {
    options: IOptionType[];
    selectedItem: IOptionType | null;
    isDisabled: boolean;
    onChange: (value: SingleValue<IOptionType>) => void;
    placeholder: string;
    tooltipContent: string;
}

const ItemMPSelect: React.FC<ItemMPSelectProps> = ({
                                                       options,
                                                       selectedItem,
                                                       isDisabled,
                                                       onChange,
                                                       placeholder,
                                                       tooltipContent
                                                   }) => (
    <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row align-items-baseline gap-1">
            <span>ItemMp</span>
            <OverlayTooltip tooltipContent={tooltipContent}/>
        </div>
        <CreatableSelect
            isClearable
            className="card border-0 d-md-block"
            closeMenuOnSelect={false}
            options={options}
            value={selectedItem ? [selectedItem] : []}
            isDisabled={isDisabled}
            placeholder={placeholder}
            onChange={(choice) => onChange(choice)}
        />
    </div>
);

export default ItemMPSelect;
